/* eslint-disable */
const initCookiePanel = () => {
  window.addEventListener('CookieScriptAcceptAll', () => acceptAll());
  window.addEventListener('CookieScriptAccept', e => acceptCategories(e.detail.categories));
  window.addEventListener('CookieScriptReject', () => rejectAll());
};

const acceptAll = async () => {
  try {
    const res = await fetch('/sitefiles/handlers/cookies.ashx', {
      method: 'POST',
      body: JSON.stringify({ accept: true }),
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!res.ok) {
      console.error('Error Accepting Cookies', res.status, res.statusText, res);
      return;
    }
  } catch (error) {
    console.error('Error Accepting Cookies', res.status, res.statusText, res);
    return;
  }
};

const acceptCategories = async categories => {
  try {
    const res = await fetch('/sitefiles/handlers/cookies.ashx', {
      method: 'POST',
      body: JSON.stringify({ accept: true, categories }),
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!res.ok) {
      console.error('Error Accepting Cookies', res.status, res.statusText, res);
      return;
    }
  } catch (error) {
    console.error('Error Accepting Cookies', res.status, res.statusText, res);
    return;
  }
};

const rejectAll = async () => {
  try {
    const res = await fetch('/sitefiles/handlers/cookies.ashx', {
      method: 'POST',
      body: JSON.stringify({ accept: false }),
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!res.ok) {
      console.error('Error Rejecting Cookies', res.status, res.statusText, res);
      return;
    }
  } catch (error) {
    console.error('Error Rejecting Cookies', res.status, res.statusText, res);
    return;
  }
};

const dismiss = () => {
  setCookie('1', { expires: 30, path: '/' });
};

initCookiePanel();
